/**
 * @module Banners | Banner Headline
 * @description Headline banner
 */
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import styles from './BannerHeadline.module.css';
import Link from 'next/link';
import { stringify } from '@/js/utils/filters';
import { trackEvent } from '@/js/helpers/tracking';
import setHtml from '@/js/utils/setHtml';

/**
   * @function handleClick
   * @description fire off tagular events
   */
const handleClick = ( event ) => {
  const { target } = event;
  const payload = JSON.parse( target.getAttribute( 'data-payload' ) );
  const { text, actionOutcome, position } = payload;

  const data = {
    elementType: 'BUTTON',
    location: 'Banner',
    position,
    text,
    actionOutcome
  };

  trackEvent( { action: 'elementClicked', data, event } );
};

/**
 * @function Component
 * @description
 */
const Component = ( { ...props } ) => {
  const {
    assetName = 'BANNER | BANNER HEADLINE | DEFAULT',
    title = 'Limited time offer',
    subtitle = null,
    legalHash = null,
    tooltip = null,
    theme = null,
    items = null,
    ctaCopy = null,
    ctaUrl = null
  } = props;

  const position = 'BANNER HEADLINE';

  const options = {
    threshold: 1,
    triggerOnce: true
  };
  const { ref, entry } = useInView( options );

  useEffect( () => {
    if ( entry?.isIntersecting === true ) {
      const data = {
        elementType: 'BANNER',
        name: assetName,
        text: `${ position } - HEADLINE VIEWED`
      };
      trackEvent( { action: 'elementViewed', data, event: {} } );
    }
  }, [ entry, assetName ] );

  return (
    <section className={ `component ${ styles.component } ${ theme && `u-theme-${ theme }` }` }>
      <div className={ styles.component__layout }>
        <div className={ styles.component__body }>
          <p ref={ ref } className={ `h5 ${ styles.component__title } ${ theme && styles[ `component__title__${ theme }` ] }` } { ...setHtml( title ) } />
          <div className={ styles.component__copyContainer }>
            <p className={ `${ styles.component__subtitle } ${ ctaCopy && ctaUrl && styles.component__subtitleCta }` } { ...setHtml( subtitle ) } />
            { legalHash && <p className={ styles.component__subtitleLegal }>{ legalHash }</p> }
            { tooltip && <p className={ styles.component__subtitleLegal }>{ tooltip }</p> }
          </div>
          { ctaCopy && ctaUrl &&
            <Link
            className={ styles.component__ctaLink }
            href={ ctaUrl }
            onClick={ handleClick }
            data-payload={ stringify( {
              text: ctaCopy,
              position: 'Banner',
              actionOutcome: 'INTERALLINK'
            } ) }>
              { ctaCopy }
            </Link>
          }
          { items && items.map( ( item, index ) => (
            <div className={ styles.component__item } key={ index }>
              <span className={ `icon icon-checkmark1 ${ styles.component__itemIcon }` } />
              <p className={ styles.component__itemText }>{item}</p>
            </div>
          ) )}
        </div>{ /* <!-- .component__body --> */ }
      </div>
    </section>
  );
};

Component.propTypes = {
  assetName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.node,
  theme: PropTypes.string,
  items: PropTypes.arrayOf( PropTypes.node )
};

export default Component;
